// src/services/api/authApi.js

/**
 * Authentication related API methods
 * @param {Object} api - axios instance
 * @returns {Object} auth API methods
 */
const authApi = (api) => {
  return {
    /**
     * Login to the application
     * @param {string} username - user email
     * @param {string} password - user password
     * @returns {Promise} response data
     */
    login: async (username, password) => {
      try {
        const response = await api.post("/api/Auth/login", {
          Email: username,
          Password: password,
        });
        return response.data;
      } catch (error) {
        throw new Error(error.response?.data?.message || "Login failed");
      }
    },

    /**
     * Register a new user (example of additional auth method)
     * @param {Object} userData - user registration data
     * @returns {Promise} response data
     */
    register: async (userData) => {
      try {
        const response = await api.post("/api/Auth/register", userData);
        return response.data;
      } catch (error) {
        throw new Error(error.response?.data?.message || "Registration failed");
      }
    },

    /**
     * Request password reset
     * @param {string} email - user email
     * @returns {Promise} response data
     */
    requestPasswordReset: async (email) => {
      try {
        const response = await api.post("/api/Auth/forgot-password", { email });
        return response.data;
      } catch (error) {
        throw new Error(error.response?.data?.message || "Request failed");
      }
    },

    /**
     * Reset password with token
     * @param {Object} resetData - password reset data with token
     * @returns {Promise} response data
     */
    resetPassword: async (resetData) => {
      try {
        const response = await api.post("/api/Auth/reset-password", resetData);
        return response.data;
      } catch (error) {
        throw new Error(
          error.response?.data?.message || "Password reset failed"
        );
      }
    },
  };
};

export default authApi;
